<template>
<div>
  <div class="wistia_embed wistia_async_b7dhfnx5jq">
    &nbsp;
  </div>

  <div
    id="conversations"
    class="tbk-vid-embed"
  >
    <a
      id="richard"
      class="embedded_video"
      href="#wistia_16n8eex57x?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="harpreet"
      class="embedded_video"
      href="#wistia_hayt2gjktn?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="gisli"
      class="embedded_video"
      href="#wistia_6x5mq3vrzk?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="jeanne"
      class="embedded_video"
      href="#wistia_dtrcgyo6v8?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="merril"
      class="embedded_video"
      href="#wistia_odmachu4bw?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="dave"
      class="embedded_video"
      href="#wistia_4bvdzx2vz0?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('b7d', 38, this.showSelect)

    this.tbk.loadCrossTime('16n', 494, this.showSelect)
    this.tbk.loadCrossTime('hay', 367, this.showSelect)
    this.tbk.loadCrossTime('6x5', 368, this.showSelect)
    this.tbk.loadCrossTime('dtr', 371, this.showSelect)
    this.tbk.loadCrossTime('odm', 273, this.showSelect)
    this.tbk.loadCrossTime('4bv', 1073, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '16n': this.tbk.autoPlay,
        hay: this.tbk.autoPlay,
        '6x5': this.tbk.autoPlay,
        dtr: this.tbk.autoPlay,
        odm: this.tbk.autoPlay,
        '4bv': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#conversations
  display: none
  a
    text-decoration: none
#richard
  position: absolute
  top: calc(100% * (210 / 360))
  left: calc(100% * (85 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (120 / 360))
#harpreet
  position: absolute
  top: calc(100% * (80 / 360))
  left: calc(100% * (85 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (120 / 360))
#gisli
  position: absolute
  top: calc(100% * (80 / 360))
  left: calc(100% * (257 / 640))
  width: calc(100% * (130 / 640))
  height: calc(100% * (120 / 360))
#jeanne
  position: absolute
  top: calc(100% * (210 / 360))
  left: calc(100% * (432 / 640))
  width: calc(100% * (130 / 640))
  height: calc(100% * (120 / 360))
#merril
  position: absolute
  top: calc(100% * (210 / 360))
  left: calc(100% * (257 / 640))
  width: calc(100% * (130 / 640))
  height: calc(100% * (120 / 360))
#dave
  position: absolute
  top: calc(100% * (80 / 360))
  left: calc(100% * (432 / 640))
  width: calc(100% * (130 / 640))
  height: calc(100% * (120 / 360))
</style>

